import { isNotEmpty, renderMessage } from '@/utils/util'
import {
  tryRefreshToken,
  currentUser,
  saveToken,
  type Token,
  currentUserHandle,
  DEMO_ID,
  localLogout,
  clearAuthCookieDirect
} from '../user/users'
import { CommonResponse, IGNORE_AUTH_PATHS, USER_REFRESH_TOKEN } from '@/apis/api'
import { getAppHost } from '@/utils/config'
import type { Ref } from 'vue'
import { CODE_OK, HTTP_400, HTTP_403, HTTP_404, HTTP_500, HTTP_503 } from '@/apis/code'
import { navigateTo } from '#app'
import { ElMessage } from 'element-plus'
import i18n from '@/utils/i18n'
import { FetchError } from '@/apis/fetchApi'
import { clientType, CLIENT_TYPE_OBITUARY } from '@/apis/api'

const whereToGo = () => {
  if (clientType.value === CLIENT_TYPE_OBITUARY) {
    navigateTo('/pages/index/index?expired=true', { replace: true })
  } else {
    toLoginPage()
  }
}

/**
 * 处理异常状态码
 * @param statusCode 状态码
 */
export function handleStatus(response: Response): Boolean {
  const url: string = response.url
  const statusCode: number | null = response.status

  if (statusCode) {
    const code = statusCode as number
    const path = url.substring(getAppHost().length)
    if (code == HTTP_403 && !IGNORE_AUTH_PATHS.includes(path) && path != USER_REFRESH_TOKEN) {
      if (currentUser != null && isNotEmpty(currentUser.value.token)) {
        tryRefreshToken(currentUser.value.token.refreshToken).then(({ data, error, statusCode }) => {
          if (error.value == null) {
            const responseData = data as Ref<CommonResponse<Token>>

            if (responseData.value.code === CODE_OK && responseData.value.data !== undefined) {
              // 刷新token
              saveToken(responseData.value.data)
            } else {
              whereToGo()
            }
          } else {
            whereToGo()
          }
        })
      } else {
        whereToGo()
      }
      return true
    }
  }
  return false
}

function toLoginPage() {
  if (currentUserHandle.value !== DEMO_ID) {
    localLogout()
  }
  clearAuthCookieDirect()
  // SSR 下没有 window，仅客户端才执行跳转与提示
  if (import.meta.server) {
    return
  }
  console.log('403且未登录，跳转登录页 , current_path:' + window.location.pathname)
  if (window.location.pathname.toString() !== '/login') {
    console.log('跳转登录页')
    navigateTo('/login', { replace: true })
    ElMessage({
      message: renderMessage(i18n.global.t('exception.not_login')),
      type: 'warning'
    })
  }
}

export function handleErr(data: Ref<any>, error: Ref<Error>, statusCode: Ref<any>) {
  if (statusCode.value === HTTP_403) {
    // token过期，统一处理.
    return
  }

  let handled = false
  // 服务端返回了明确的错误信息，提示错误信息
  if (error.value instanceof FetchError) {
    const data = (error as Ref<FetchError>).value.responseData as CommonResponse<any>
    if (data) {
      ElMessage({
        message: renderMessage(data.message),
        type: 'warning'
      })
      handled = true
    }
  }

  // 其他软件错误导致
  if (!handled) {
    const s = statusCode as Ref<number>
    const d = data as Ref<CommonResponse<any>>
    // console.log('handleErr', data, error, statusCode)

    // 尝试获取服务端信息
    if (isNotEmpty(d.value)) {
      ElMessage({
        message: renderMessage(d.value.message),
        type: 'error'
      })
    } else if (error.value != null) {
      // 兜底处理
      console.log('======= handleErr ===', statusCode.value, data, error.value.message)
      if (s.value === HTTP_404) {
        ElMessage({
          message: renderMessage(i18n.global.t('exception.not_found')),
          type: 'warning'
        })
        return true
      } else if (s.value === HTTP_400) {
        ElMessage({
          message: renderMessage(i18n.global.t('exception.param_wrong')),
          type: 'warning'
        })
        return true
      } else if (s.value === HTTP_500) {
        ElMessage({
          message: renderMessage(i18n.global.t('exception.server_error')),
          type: 'warning'
        })
        return true
      } else if (s.value == HTTP_503) {
        ElMessage({
          message: renderMessage(i18n.global.t('exception.server_busy')),
          type: 'warning'
        })
        return true
      } else {
        ElMessage({
          message: renderMessage(i18n.global.t('exception.network_error')),
          type: 'error'
        })
      }
    }
  }
}
